<template>
  <div class="care-setting-ac">
    <div class="box">
      <h3>账号注销后将放弃以下权利</h3>
      <div class="content bg1">
        <div class="item">
          <div class="num"><span>1</span></div>
          <div class="des">
            个人信息、历史订单及相关权益均会被清空且无法恢复找回
          </div>
        </div>
        <div class="item">
          <div class="num"><span>2</span></div>
          <div class="des">
            您之前绑定的三方账号将被解绑
          </div>
        </div>
        <div class="item">
          <div class="num"><span>3</span></div>
          <div class="des">
            您在品胜系统的其它账号也将被注销
            <p>
              详见底部《账号注销协议》
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <h3>请确认无以下情况，否则将无法注销</h3>
      <div class="content bg2">
        <div class="item">
          <div class="des">
            您有未激活、激活失败或保障中的无忧卡
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="btn"><y-button @click="submit">确认申请注销</y-button></div>
      <div class="agreement-select">
        <div class="check-c-box">
          <van-checkbox  v-model="isCheckAgreement" checked-color="#000" />
        </div>
        <div class="agreement-list">我已阅读并同意
          <span class="info-link" @click="goto('/sysAgreement?Module=账号注销协议')">《账号注销协议》</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Vue from "vue";
    import { Cell,Checkbox,Dialog,Toast } from "vant";
    import { httpOpen } from "../../scripts/network";
    import { USER_INFO } from "../../store/mutation-types";
	
    Vue.use(Cell);
    Vue.use(Checkbox);
    Vue.use(Dialog)
    Vue.use(Toast)
    export default {
        name: "CareSettingAC",
        data() {
            return {
                isCheckAgreement:false
            };
        },
        created() {

        },
        methods:{
             submit(){
                if(!this.isCheckAgreement){
                    Dialog({ message: '请勾选协议' });
                    return
                }

                 Dialog.confirm({
                     title: '提示',
                     message:
                         '确认注销您的账号吗？',
                 })
                     .then( async() => {
                         Toast.loading({duration:0, message: "正在注销账号" });
                         const ret = await httpOpen("/WuYouCard/UserCancellation",{
                             type: "post"
                         });
                         Toast.clear();
                         if (ret.Status) {
							this.$store.commit(USER_INFO, '');
							window.local.clear();
							Dialog({
								message: '注销成功'
							}).then(() => {
								this.goto('/care/anonymous')
							});
                         } else {
                             Dialog({ title: '申请账号注销失败',confirmButtonText:'关闭',message: ret.Message || '系统繁忙' })
                         }
                     })
                     .catch(() => {
                         // on cancel
                     });
            }
        }
    };
</script>
<style lang="less" scoped>
  .care-setting-ac{
    padding: 12px 12px 60px;
    min-height: 100vh;
    background-color: #f4f4f4;
    box-sizing: border-box;
    .box{
      background: #FFFFFF;
      border-radius: 8px;
      padding: 16px 12px;
      margin-bottom: 7px;
      >h3{
        font-size: 14px;
        color: #000000;
      }
      .content{
        border-radius: 8px;
        padding: 13px 17px;
        .item{
          display: flex;
          padding: 13px 0;
          .num{
            >span{
              display: inline-block;
              text-align: center;
              width: 16px;
              height: 17px;
              line-height: 17px;
              background: #404040;
              font-size: 13px;
              color: #FFFFFF;
              border-radius: 50%;
            }
          }
          .des{
            font-size: 14px;
            color: #000000;
            line-height: 17px;
            margin-left: 17px;
            p{
              font-size: 12px;
              color: #666666;
              line-height: 17px;
            }
          }
        }
        &.bg1{
          background: #FFF9EF;
        }
        &.bg2{
          background: #FFF0F0;
          .item{
            position: relative;
            &:before{
              position: absolute;
              content: '';
              top:50%;
              margin-top: -4px;
              left: 0;
              width: 8px;
              height: 8px;
              background: #FF8585;
              border-radius: 50%;
            }
          }
        }
      }
    }
    .bottom{
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 14px;
      .btn{
      }
      .agreement-select{
        font-size: 14px;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        .agreement-list{
          margin-left: 12px;
          .info-link{
            color: #338BE4;
          }
        }
      }
    }
  }
</style>
